import React, { type ReactElement } from 'react'
import {
  Card,
  CardBody,
  Heading,
  Text,
  Button,
  Box,
  GridItem,
  Img
} from '@chakra-ui/react'
import { SanityImage } from 'sanity-image'
import { client as SanityClient } from '../renderer/sanity'
import { format } from 'date-fns'

interface BlogPostType {
  _id: string
  title: string
  slug: {
    current: string
  }
  mainImage: any
  body: any
  publishedAt: string
}

function BlogPost(props: { post: BlogPostType }): ReactElement {
  const { post } = props
  const formatedDate = format(new Date(post.publishedAt), 'PPP')
  return (
    <GridItem>
      <Card
        bg="yellow.300"
        as="a"
        href={`/blog/${post.slug.current}`}
        sx={{
          // transform: `perspective(900px) rotateY(${
          //   rotations * 3
          // }deg) rotate(${rotations}deg)`,
          boxShadow: 'sm',
          transition: 'all 200ms ease',
          height: '100%',
          borderRadius: 0,
          '.bend': {
            position: 'absolute',
            bg: 'white',
            bottom: '0px',
            right: '0px',
            borderStyle: 'solid',
            h: 'auto',
            aspectRatio: '1/1',
            w: '5%',
            boxShadow: '0px 2px 0px 0px white, 2px 0px 0px 0px white',
            transition: 'all 0.5s',
            zIndex: 2,
            overflow: 'hidden',
            '&:after': {
              pointerEvents: 'none',
              color: 'yellow.100',
              background:
                'linear-gradient(135deg, currentcolor calc(50% - 1px), rgba(232,232,232,1) 50%, rgba(255,255,255,0) 50.2%, rgba(255,255,255,0) 100%)',
              content: '""',
              display: 'block',
              pos: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0
            },
            button: {
              pos: 'absolute',
              right: '20px',
              bottom: '20px'
            }
          },
          '&:hover': {
            transitionDelay: '.1s'
          },
          '&:hover .bend': {
            w: '25%'
          }
        }}
      >
        <Img
          as={SanityImage}
          id={props.post.mainImage.asset._ref}
          projectId={SanityClient.config().projectId}
          dataset={SanityClient.config().dataset}
          width="500px"
          minW="100%"
          queryParams={{ q: 100 }}
          alt={post.mainImage.alt}
          objectFit="cover"
          sizes="(min-width: 1240px) 500px, calc((100vw - 40px - 30px) / 3)"
        />
        <CardBody pos="relative" pb="70px">
          <Heading size="lg" mb="0">
            {post.title}
          </Heading>
          <Text fontSize="14px" fontWeight="600" mt="0" mb="20px">
            {formatedDate}
          </Text>
          <Button
            as="span"
            variant="outlineNegative"
            pos="absolute"
            left="20px"
            bottom="20px"
          >
            Continue Reading
          </Button>
        </CardBody>
        <Box className="bend"></Box>
      </Card>
    </GridItem>
  )
}

export { BlogPost, type BlogPostType }
